// This file is generated by
// services/coaches/cmd/school_picker/generate_typescript.
// Do not edit directly.

// Map of ISO-3166-2 codes to the names of admin level one entities.
export const ADMIN_LEVEL_ONE_CODES_TO_NAMES: Record<string, string> = {
    "00": "NCR",
    "01": "REGION I",
    "02": "REGION II",
    "03": "REGION III",
    "05": "REGION V",
    "06": "REGION VI",
    "07": "REGION VII",
    "08": "REGION VIII",
    "09": "REGION IX",
    "10": "REGION X",
    "11": "REGION XI",
    "12": "REGION XII",
    "13": "CARAGA",
    "14": "BARMM",
    "15": "CAR",
    "18": "NIR",
    "40": "REGION IV-A",
    "41": "MIMAROPA",
};

// Map of the administrative levels used in country.
//
// Level 1 is keyed by ISO-3166-2 code.
// Level 2 is keyed by the names of admin-level-two entities.
// Level 3 contains the names of localities.
export const ADMIN_LEVELS: Record<string, Record<string, string[]>> = {
    "00": {
        "CALOOCAN CITY": [
            "AROMAR (AROMAHAN-MARULAS)",
            "CALOOCAN NORTH I",
            "CALOOCAN NORTH II",
            "CALOOCAN NORTH III",
            "CALOOCAN NORTH IV",
            "POBCARAN (POBLACION-CALIPARAN)",
            "TANQUE",
        ],
        "CITY OF SAN JUAN": ["SAN JUAN DISTRICT I", "SAN JUAN DISTRICT II"],
        "LAS PIÑAS CITY": ["LAS PIÑAS CITY I", "LAS PIÑAS CITY II"],
        "MAKATI CITY": [
            "MAKATI CITY DISTRICT I",
            "MAKATI CITY DISTRICT II",
            "MAKATI CITY DISTRICT III",
            "MAKATI CITY DISTRICT IV",
            "MAKATI CITY DISTRICT V",
            "MAKATI CITY DISTRICT VI",
        ],
        "MALABON CITY": [
            "MALABON DISTRICT I",
            "MALABON DISTRICT II",
            "MALABON DISTRICT III",
            "MALABON DISTRICT IV",
            "MALABON DISTRICT V",
        ],
        "MANDALUYONG CITY": [
            "MANDALUYONG CITY DISTRICT I",
            "MANDALUYONG CITY DISTRICT II",
        ],
        MANILA: [
            "MALATE",
            "PACO I",
            "PACO II",
            "PANDACAN I",
            "PANDACAN II",
            "SAMPALOC I",
            "SAMPALOC II",
            "SAMPALOC III",
            "SAMPALOC IV",
            "SAMPALOC IX",
            "SAMPALOC V",
            "SAMPALOC VI",
            "SAMPALOC VII",
            "SAMPALOC VIII",
            "SAN ANDRES",
            "SAN NICOLAS",
            "SINGALONG",
            "STA. ANA I",
            "STA. ANA II",
            "STA. ANA III",
            "STA. CRUZ I",
            "STA. CRUZ II",
            "STA. CRUZ III",
            "STA. CRUZ IV",
            "STA. CRUZ V",
            "TONDO I",
            "TONDO II",
            "TONDO III",
            "TONDO IV",
            "TONDO IX",
            "TONDO V",
            "TONDO VI",
            "TONDO VII",
            "TONDO VIII",
            "TONDO X",
            "TONDO XI",
            "TONDO XII",
            "TONDO XIII",
            "TONDO XIV",
        ],
        "MARIKINA CITY": [
            "MARIKINA CITY DISTRICT I",
            "MARIKINA CITY DISTRICT II",
        ],
        "MUNTINLUPA CITY": [
            "MUNTINLUPA CITY DISTRICT I",
            "MUNTINLUPA CITY DISTRICT II",
        ],
        NAVOTAS: ["NAVOTAS DISTRICT I", "NAVOTAS DISTRICT II"],
        "PARANAQUE CITY": [
            "PARANAQUE CITY DISTRICT I",
            "PARANAQUE CITY DISTRICT II",
            "PARANAQUE CITY DISTRICT III",
        ],
        "PASAY CITY": [
            "PASAY CITY EAST DISTRICT",
            "PASAY CITY NORTH DISTRICT",
            "PASAY CITY SOUTH DISTRICT",
            "PASAY CITY WEST DISTRICT",
        ],
        "PASIG CITY": [
            "PASIG CITY DISTRICT I",
            "PASIG CITY DISTRICT II",
            "PASIG CITY DISTRICT III",
            "PASIG CITY DISTRICT IV",
            "PASIG CITY DISTRICT V",
        ],
        "QUEZON CITY": [
            "SCHOOL DISTRICT I",
            "SCHOOL DISTRICT II",
            "SCHOOL DISTRICT III",
            "SCHOOL DISTRICT IV",
            "SCHOOL DISTRICT IX",
            "SCHOOL DISTRICT V",
            "SCHOOL DISTRICT VI",
            "SCHOOL DISTRICT VII",
            "SCHOOL DISTRICT VIII",
            "SCHOOL DISTRICT X",
            "SCHOOL DISTRICT XI",
            "SCHOOL DISTRICT XII",
            "SCHOOL DISTRICT XIII",
            "SCHOOL DISTRICT XIV",
            "SCHOOL DISTRICT XIX",
            "SCHOOL DISTRICT XV",
            "SCHOOL DISTRICT XVI",
            "SCHOOL DISTRICT XVII",
            "SCHOOL DISTRICT XVIII",
            "SCHOOL DISTRICT XX",
        ],
        "TAGUIG CITY AND PATEROS": [
            "MAKATI CITY DISTRICT I",
            "MAKATI CITY DISTRICT II",
            "PATEROS",
            "TAGUIG DISTRICT I",
            "TAGUIG DISTRICT II",
            "TAGUIG DISTRICT III",
        ],
        "VALENZUELA CITY": [
            "VALENZUELA CITY CENTRAL DISTRICT",
            "VALENZUELA CITY EAST DISTRICT",
            "VALENZUELA CITY NORTH DISTRICT",
            "VALENZUELA CITY SOUTH DISTRICT",
        ],
    },
    "01": {
        "ALAMINOS CITY": ["DISTRICT I", "DISTRICT II", "DISTRICT III"],
        "BATAC CITY": ["BATAC I", "BATAC II"],
        "CANDON CITY": ["DISTRICT I", "DISTRICT II"],
        "DAGUPAN CITY": [
            "DAGUPAN CITY DISTRICT I",
            "DAGUPAN CITY DISTRICT II",
            "DAGUPAN CITY DISTRICT III",
            "DAGUPAN CITY DISTRICT IV",
        ],
        "ILOCOS NORTE": [
            "ADAMS-PAGUDPUD",
            "BACARRA I",
            "BACARRA II",
            "BADOC",
            "BANGUI",
            "BANNA (ESPIRITU)",
            "BURGOS",
            "CURRIMAO",
            "DINGRAS I",
            "DINGRAS II",
            "MARCOS-NUEVA ERA",
            "PAOAY",
            "PASUQUIN",
            "PIDDIG",
            "PINILI",
            "SAN NICOLAS",
            "SARRAT",
            "SOLSONA",
            "VINTAR I",
            "VINTAR II",
        ],
        "ILOCOS SUR": [
            "ALILEM-SUGPON",
            "BANAYOYO-LIDLIDDA-SAN EMILIO",
            "BANTAY",
            "BURGOS-SAN ESTEBAN",
            "CABUGAO",
            "CAOAYAN",
            "CERVANTES-QUIRINO",
            "MAGSINGAL",
            "NARVACAN NORTH",
            "NARVACAN SOUTH-NAGBUKEL",
            "SALCEDO-GALIMUYOD-SIGAY-DEL PILAR",
            "SAN JUAN",
            "SAN VICENTE",
            "SANTA",
            "SANTIAGO",
            "SINAIT",
            "STA. CATALINA",
            "STA. CRUZ",
            "STA. LUCIA",
            "STA. MARIA",
            "STO. DOMINGO-SAN ILDEFONSO",
            "SUYO",
            "TAGUDIN",
        ],
        "LA UNION": [
            "AGOO EAST",
            "AGOO WEST",
            "ARINGAY",
            "BACNOTAN",
            "BAGULIN",
            "BALAOAN",
            "BANGAR",
            "BAUANG NORTH",
            "BAUANG SOUTH",
            "BURGOS",
            "CABA",
            "LUNA I",
            "LUNA II",
            "NAGUILIAN",
            "PUGO",
            "ROSARIO",
            "SAN GABRIEL",
            "SAN JUAN",
            "SANTOL",
            "STO. TOMAS",
            "SUDIPEN",
            "TUBAO",
        ],
        "LAOAG CITY": [
            "LAOAG CITY DISTRICT I",
            "LAOAG CITY DISTRICT II",
            "LAOAG CITY DISTRICT III",
        ],
        "PANGASINAN I, LINGAYEN": [
            "AGNO",
            "AGUILAR",
            "ANDA",
            "BANI",
            "BASISTA",
            "BAYAMBANG I",
            "BAYAMBANG II",
            "BINMALEY I",
            "BINMALEY II",
            "BOLINAO",
            "BUGALLON I",
            "BUGALLON II",
            "BURGOS",
            "CALASIAO I",
            "CALASIAO II",
            "DASOL",
            "INFANTA",
            "LABRADOR",
            "LINGAYEN I",
            "LINGAYEN II",
            "LINGAYEN III",
            "MABINI",
            "MALASIQUI I",
            "MALASIQUI II",
            "MANGATAREM I",
            "MANGATAREM II",
            "MAPANDAN",
            "STA. BARBARA I",
            "STA. BARBARA II",
            "SUAL",
            "URBIZTONDO",
        ],
        "PANGASINAN II, BINALONAN": [
            "ALCALA",
            "ASINGAN I",
            "ASINGAN II",
            "BALUNGAO",
            "BAUTISTA",
            "BINALONAN I",
            "BINALONAN II",
            "LAOAC",
            "MANAOAG",
            "MANGALDAN I",
            "MANGALDAN II",
            "NATIVIDAD",
            "POZORRUBIO I",
            "POZORRUBIO II",
            "ROSALES I",
            "ROSALES II",
            "SAN FABIAN I",
            "SAN FABIAN II",
            "SAN JACINTO",
            "SAN MANUEL",
            "SAN NICOLAS I",
            "SAN NICOLAS II",
            "SAN QUINTIN",
            "SISON",
            "STA. MARIA",
            "STO. TOMAS",
            "TAYUG I",
            "TAYUG II",
            "UMINGAN I",
            "UMINGAN II",
            "VILLASIS I",
            "VILLASIS II",
        ],
        "SAN CARLOS CITY": [
            "SAN CARLOS CITY DISTRICT I",
            "SAN CARLOS CITY DISTRICT II",
            "SAN CARLOS CITY DISTRICT III",
            "SAN CARLOS CITY DISTRICT IV",
        ],
        "SAN FERNANDO CITY": ["SAN FERNANDO I", "SAN FERNANDO II"],
        "URDANETA CITY": [
            "URDANETA CITY DISTRICT I",
            "URDANETA CITY DISTRICT II",
        ],
        "VIGAN CITY": ["DISTRICT I", "DISTRICT II", "DISTRICT III"],
    },
    "02": {
        BATANES: ["BASCO", "ITBAYAT", "IVANA-UYUGAN", "MAHATAO", "SABTANG"],
        CAGAYAN: [
            "ABULUG",
            "ALCALA EAST",
            "ALCALA WEST",
            "ALLACAPAN NORTH",
            "ALLACAPAN SOUTH",
            "AMULUNG EAST",
            "AMULUNG WEST",
            "APARRI EAST",
            "APARRI SOUTH EDUCATIONAL ZONE",
            "APARRI WEST",
            "BAGGAO EAST",
            "BAGGAO NORTH",
            "BAGGAO SOUTH",
            "BAGGAO WEST",
            "BALLESTEROS",
            "BUGUEY NORTH",
            "BUGUEY SOUTH",
            "CALAYAN EAST",
            "CALAYAN WEST",
            "CAMALANIUGAN",
            "CLAVERIA EAST",
            "ENRILE EAST",
            "ENRILE WEST",
            "GATTARAN CENTRAL",
            "GATTARAN EAST",
            "GATTARAN WEST",
            "GONZAGA EAST",
            "GONZAGA WEST",
            "IGUIG",
            "LAL-LO CENTRAL",
            "LAL-LO NORTH",
            "LAL-LO SOUTH",
            "LASAM EAST",
            "LASAM WEST",
            "PAMPLONA",
            "PENABLANCA EAST",
            "PENABLANCA WEST",
            "PIAT",
            "RIZAL",
            "SANCHEZ MIRA",
            "SOLANA NORTH",
            "SOLANA SOUTH",
            "SOLANA WEST EDUCATIONAL ZONE",
            "STA. ANA",
            "STA. PRAXEDES",
            "STA. TERESITA",
            "STO. NINO",
            "TUAO EAST",
            "TUAO WEST",
        ],
        "CAUAYAN CITY": [
            "CAUAYAN EAST DISTRICT",
            "CAUAYAN NORTH DISTRICT",
            "CAUAYAN NORTHEAST DISTRICT",
            "CAUAYAN SOUTH DISTRICT",
            "CAUAYAN WEST DISTRICT",
        ],
        "CITY OF ILAGAN": [
            "EAST",
            "NORTH",
            "NORTHWEST",
            "SAN ANTONIO",
            "SOUTH",
            "WEST",
        ],
        ISABELA: [
            "ALICIA EAST",
            "ALICIA NORTH",
            "ALICIA SOUTH",
            "ANGADANAN EAST",
            "ANGADANAN WEST",
            "AURORA",
            "BENITO SOLIVEN",
            "BURGOS",
            "CABAGAN",
            "CABATUAN EAST",
            "CABATUAN WEST",
            "CORDON NORTH",
            "CORDON SOUTH",
            "DELFIN ALBANO",
            "ECHAGUE EAST",
            "ECHAGUE SOUTH",
            "ECHAGUE WEST",
            "GAMU",
            "JONES EAST",
            "JONES WEST",
            "LUNA",
            "MALLIG",
            "NAGUILIAN",
            "PALANAN",
            "QUEZON",
            "QUIRINO",
            "RAMON",
            "REINA MERCEDES",
            "ROXAS EAST",
            "ROXAS WEST",
            "SAN AGUSTIN",
            "SAN GUILLERMO",
            "SAN ISIDRO",
            "SAN MANUEL",
            "SAN MARIANO I",
            "SAN MARIANO II",
            "SAN MATEO NORTH",
            "SAN MATEO SOUTH",
            "SAN PABLO",
            "STA. MARIA",
            "STO. TOMAS",
            "TUMAUINI NORTH",
            "TUMAUINI SOUTH",
        ],
        "NUEVA VIZCAYA": [
            "ALFONSO CASTAÑEDA",
            "AMBAGUIO",
            "ARITAO EAST",
            "ARITAO WEST",
            "BAGABAG I",
            "BAGABAG II",
            "BAMBANG I",
            "BAMBANG II",
            "BAYOMBONG I",
            "BAYOMBONG II",
            "DIADI",
            "DUPAX DEL NORTE I",
            "DUPAX DEL NORTE II",
            "DUPAX DEL SUR",
            "EASTERN KAYAPA",
            "KASIBU EAST",
            "KASIBU WEST",
            "QUEZON",
            "SOLANO I",
            "SOLANO II",
            "STA. FE",
            "VILLAVERDE",
            "WESTERN KAYAPA",
        ],
        QUIRINO: [
            "AGLIPAY",
            "CABARROGUIS",
            "DIFFUN I",
            "DIFFUN II",
            "MADDELA ZONE I",
            "MADDELA ZONE II",
            "NAGTIPUNAN",
            "SAGUDAY",
        ],
        "SANTIAGO CITY": [
            "SANTIAGO EAST",
            "SANTIAGO NORTH",
            "SANTIAGO SOUTH",
            "SANTIAGO WEST",
        ],
        "TUGUEGARAO CITY": [
            "TUGUEGARAO EAST EDUCATIONAL ZONE",
            "TUGUEGARAO NORTH EDUCATIONAL ZONE",
            "TUGUEGARAO NORTHEAST EDUCATIONAL ZONE",
            "TUGUEGARAO WEST EDUCATIONAL ZONE",
        ],
    },
    "03": {
        "ANGELES CITY": [
            "EAST DISTRICT",
            "NORTH DISTRICT",
            "SOUTH DISTRICT",
            "WEST DISTRICT",
        ],
        AURORA: [
            "BALER",
            "CASIGURAN",
            "DILASAG",
            "DINALUNGAN",
            "DINGALAN",
            "DIPACULAO",
            "MA. AURORA",
            "SAN LUIS",
        ],
        "BALANGA CITY": ["BALANGA CITY EAST", "BALANGA CITY WEST"],
        BATAAN: [
            "ABUCAY",
            "BAGAC",
            "DINALUPIHAN EAST",
            "DINALUPIHAN WEST",
            "HERMOSA",
            "LIMAY",
            "MARIVELES",
            "MORONG",
            "ORANI",
            "ORION",
            "PILAR",
            "SAMAL",
        ],
        BULACAN: [
            "ANGAT",
            "BALAGTAS",
            "BALIUAG NORTH",
            "BOCAUE",
            "BULACAN",
            "BUSTOS",
            "CALUMPIT",
            "DONA REMEDIOS TRINIDAD",
            "GUIGUINTO",
            "HAGONOY EAST",
            "HAGONOY WEST",
            "MARILAO",
            "NORZAGARAY",
            "OBANDO",
            "PANDI",
            "PAOMBONG",
            "PLARIDEL",
            "PULILAN",
            "SAN ILDEFONSO NORTH",
            "SAN ILDEFONSO SOUTH",
            "SAN MIGUEL NORTH",
            "SAN MIGUEL SOUTH",
            "SAN RAFAEL",
            "STA. MARIA",
        ],
        "CABANATUAN CITY": [
            "CABANATUAN CITY EAST DISTRICT",
            "CABANATUAN CITY NORTH DISTRICT",
            "CABANATUAN CITY SOUTH DISTRICT",
            "CABANATUAN CITY WEST DISTRICT",
        ],
        "CITY OF BALIWAG": ["BALIUAG NORTH", "BALIUAG SOUTH"],
        "CITY OF SAN JOSE DEL MONTE": [
            "SAN JOSE DEL MONTE EAST",
            "SAN JOSE DEL MONTE WEST",
        ],
        "GAPAN CITY": ["GAPAN NORTH", "GAPAN SOUTH"],
        "MABALACAT CITY": [
            "MABALACAT EAST",
            "MABALACAT NORTH",
            "MABALACAT SOUTH",
        ],
        "MALOLOS CITY": ["NORTH DISTRICT", "SOUTH DISTRICT"],
        "MEYCAUAYAN CITY": ["MEYCAUAYAN EAST", "MEYCAUAYAN WEST"],
        "NUEVA ECIJA": [
            "ALIAGA",
            "BONGABON",
            "CABIAO",
            "CARRANGLAN",
            "CUYAPO",
            "GABALDON",
            "GEN. M. NATIVIDAD",
            "GEN. TINIO",
            "GUIMBA EAST",
            "GUIMBA WEST",
            "JAEN",
            "LAUR",
            "LICAB",
            "LLANERA",
            "LUPAO",
            "NAMPICUAN",
            "PALAYAN CITY",
            "PANTABANGAN",
            "PENARANDA",
            "QUEZON",
            "RIZAL",
            "SAN ANTONIO",
            "SAN ISIDRO",
            "SAN LEONARDO",
            "STA. ROSA",
            "STO. DOMINGO",
            "TALAVERA NORTH",
            "TALAVERA SOUTH",
            "TALUGTUG",
            "ZARAGOZA",
        ],
        "OLONGAPO CITY": [
            "OLONGAPO CITY DISTRICT I",
            "OLONGAPO CITY DISTRICT II",
            "OLONGAPO CITY DISTRICT III",
            "OLONGAPO CITY DISTRICT IV",
        ],
        PAMPANGA: [
            "APALIT",
            "ARAYAT EAST",
            "ARAYAT WEST",
            "BACOLOR NORTH",
            "BACOLOR SOUTH",
            "CANDABA EAST",
            "CANDABA NORTH",
            "CANDABA WEST",
            "FLORIDABLANCA EAST",
            "FLORIDABLANCA WEST",
            "GUAGUA EAST",
            "GUAGUA WEST",
            "LUBAO EAST",
            "LUBAO NORTH",
            "LUBAO WEST",
            "MACABEBE EAST",
            "MACABEBE WEST",
            "MAGALANG NORTH",
            "MAGALANG SOUTH",
            "MASANTOL NORTH",
            "MASANTOL SOUTH",
            "MEXICO NORTH",
            "MEXICO SOUTH",
            "MEXICO WEST",
            "MINALIN",
            "PORAC EAST",
            "PORAC WEST",
            "SAN LUIS",
            "SAN SIMON",
            "SASMUAN",
            "STA. ANA",
            "STA. RITA",
            "STO. TOMAS",
        ],
        "SAN FERNANDO CITY": [
            "SAN FERNANDO EAST",
            "SAN FERNANDO NORTH",
            "SAN FERNANDO WEST",
        ],
        "SAN JOSE CITY": ["SAN JOSE CITY EAST", "SAN JOSE CITY WEST"],
        "SCIENCE CITY OF MUÑOZ": ["MUNOZ"],
        TARLAC: [
            "ANAO",
            "BAMBAN",
            "CAMILING CENTRAL",
            "CAMILING EAST",
            "CAMILING WEST",
            "CAPAS EAST",
            "CAPAS WEST",
            "CONCEPCION EAST",
            "CONCEPCION NORTH",
            "CONCEPCION SOUTH",
            "CONCEPCION WEST",
            "GERONA NORTH",
            "GERONA SOUTH",
            "LA PAZ NORTH",
            "LA PAZ SOUTH",
            "MAYANTOC",
            "MONCADA NORTH",
            "MONCADA SOUTH",
            "PANIQUI NORTH",
            "PANIQUI SOUTH",
            "PURA",
            "RAMOS",
            "SAN CLEMENTE",
            "SAN JOSE",
            "SAN MANUEL",
            "STA. IGNACIA",
            "VICTORIA EAST",
            "VICTORIA WEST",
        ],
        "TARLAC CITY": [
            "TARLAC CENTRAL DISTRICT",
            "TARLAC EAST DISTRICT",
            "TARLAC NORTH DISTRICT A",
            "TARLAC NORTH DISTRICT B",
            "TARLAC SOUTH DISTRICT A",
            "TARLAC SOUTH DISTRICT B",
            "TARLAC WEST DISTRICT A",
            "TARLAC WEST DISTRICT B",
            "TARLAC WEST DISTRICT C",
        ],
        ZAMBALES: [
            "BOTOLAN NORTH",
            "BOTOLAN SOUTH",
            "CABANGAN",
            "CANDELARIA",
            "CASTILLEJOS",
            "IBA",
            "MASINLOC",
            "PALAUIG",
            "SAN ANTONIO",
            "SAN FELIPE",
            "SAN MARCELINO",
            "SAN NARCISO",
            "STA. CRUZ NORTH",
            "STA. CRUZ SOUTH",
            "SUBIC",
        ],
    },
    "05": {
        ALBAY: [
            "BACACAY EAST",
            "BACACAY SOUTH",
            "BACACAY WEST",
            "CAMALIG NORTH",
            "CAMALIG SOUTH",
            "DARAGA NORTH",
            "DARAGA SOUTH",
            "GUINOBATAN EAST",
            "GUINOBATAN WEST",
            "JOVELLAR",
            "LIBON EAST",
            "LIBON WEST",
            "MALILIPOT",
            "MALINAO",
            "MANITO",
            "OAS NORTH",
            "OAS SOUTH",
            "PIODURAN EAST (PIODURAN SOUTH)",
            "PIODURAN WEST (PIODURAN NORTH)",
            "POLANGUI NORTH",
            "POLANGUI SOUTH",
            "RAPU-RAPU EAST (RAPU-RAPU)",
            "RAPU-RAPU WEST",
            "STO. DOMINGO",
            "TIWI",
        ],
        "CAMARINES NORTE": [
            "BASUD",
            "CAPALONGA",
            "DAET NORTH",
            "DAET SOUTH",
            "JOSE PANGANIBAN EAST",
            "JOSE PANGANIBAN WEST",
            "LABO EAST",
            "LABO WEST",
            "MERCEDES",
            "PARACALE",
            "SN VICENTE-SAN LORENZO RUIZ",
            "STA. ELENA",
            "TALISAY",
            "VINZONS",
        ],
        "CAMARINES SUR": [
            "BAAO",
            "BALATAN",
            "BATO",
            "BUHI",
            "BULA",
            "CABUSAO",
            "CALABANGA",
            "CAMALIGAN",
            "CANAMAN",
            "CARAMOAN",
            "DEL GALLEGO",
            "GARCHITORENA",
            "GOA",
            "LAGONOY NORTH",
            "LAGONOY SOUTH",
            "LIBMANAN NORTH",
            "LIBMANAN SOUTH",
            "LUPI",
            "MAGARAO-BOMBON",
            "MILAOR-GAINZA",
            "MINALABAC",
            "NABUA EAST",
            "NABUA WEST",
            "OCAMPO",
            "PAMPLONA",
            "PARUBCAN-PRESENTACION",
            "PASACAO",
            "PILI",
            "RAGAY",
            "SAGÑAY",
            "SAN FERNANDO",
            "SAN JOSE",
            "SIPOCOT NORTH",
            "SIPOCOT SOUTH",
            "SIRUMA",
            "TIGAON",
            "TINAMBAC NORTH",
            "TINAMBAC SOUTH",
        ],
        CATANDUANES: [
            "BAGAMANOC NORTH",
            "BAGAMANOC SOUTH",
            "BARAS NORTH",
            "BARAS SOUTH",
            "BATO EAST",
            "BATO WEST",
            "CARAMORAN NORTH",
            "CARAMORAN SOUTH",
            "GIGMOTO",
            "PANDAN EAST",
            "PANDAN WEST",
            "PANGANIBAN",
            "SAN ANDRES EAST",
            "SAN ANDRES WEST",
            "SAN MIGUEL NORTH",
            "SAN MIGUEL SOUTH",
            "VIGA EAST",
            "VIGA WEST",
            "VIRAC NORTH",
            "VIRAC SOUTH",
        ],
        "IRIGA CITY": [
            "IRIGA CENTRAL DISTRICT",
            "IRIGA NORTH DISTRICT",
            "IRIGA SOUTH DISTRICT",
        ],
        "LEGASPI CITY": [
            "ALBAY I DISTRICT",
            "ALBAY II DISTRICT",
            "LEGAZPI PORT I DISTRICT",
            "LEGAZPI PORT II DISTRICT",
        ],
        "LIGAO CITY": [
            "LIGAO EAST DISTRICT",
            "LIGAO SOUTH DISTRICT",
            "LIGAO WEST DISTRICT",
        ],
        MASBATE: [
            "AROROY EAST",
            "AROROY WEST",
            "BALENO",
            "BALUD NORTH",
            "BALUD SOUTH",
            "BATUAN",
            "CATAINGAN EAST",
            "CATAINGAN WEST",
            "CAWAYAN EAST (CAWAYAN)",
            "CAWAYAN WEST",
            "CLAVERIA NORTH",
            "CLAVERIA SOUTH",
            "DIMASALANG",
            "ESPERANZA",
            "MANDAON NORTH",
            "MANDAON SOUTH",
            "MILAGROS EAST",
            "MILAGROS WEST",
            "MOBO NORTH",
            "MOBO SOUTH",
            "MONREAL",
            "PALANAS NORTH",
            "PALANAS SOUTH",
            "PIO V. CORPUZ",
            "PLACER EAST",
            "PLACER WEST",
            "SAN FERNANDO",
            "SAN JACINTO",
            "SAN PASCUAL NORTH",
            "SAN PASCUAL SOUTH",
            "USON SOUTH",
            "USON-NORTH",
        ],
        "MASBATE CITY": [
            "MASBASTE NORTH DISTRICT 1",
            "MASBASTE NORTH DISTRICT 2",
            "MASBATE SOUTH DISTRICT 1",
            "MASBATE SOUTH DISTRICT 2",
        ],
        "NAGA CITY": [
            "NAGA EAST DISTRICT",
            "NAGA NORTH DISTRICT",
            "NAGA SOUTH DISTRICT",
            "NAGA WEST DISTRICT",
        ],
        SORSOGON: [
            "BARCELONA",
            "BULAN NORTH",
            "BULAN SOUTH",
            "BULUSAN",
            "CASIGURAN",
            "CASTILLA EAST",
            "CASTILLA WEST",
            "DONSOL EAST",
            "DONSOL WEST",
            "GUBAT NORTH",
            "GUBAT SOUTH",
            "IROSIN",
            "JUBAN",
            "MAGALLANES NORTH",
            "MAGALLANES SOUTH",
            "MATNOG",
            "PILAR I",
            "PILAR II",
            "PRIETO DIAZ",
            "STA. MAGDALENA",
        ],
        "SORSOGON CITY": [
            "BACON EAST",
            "BACON WEST",
            "SORSOGON EAST",
            "SORSOGON WEST",
        ],
        "TABACO CITY": [
            "TABACO EAST",
            "TABACO NORTH",
            "TABACO SOUTH",
            "TABACO WEST",
        ],
    },
    "06": {
        AKLAN: [
            "ALTAVAS",
            "BALETE",
            "BANGA",
            "BATAN",
            "BURUANGA",
            "IBAJAY I",
            "IBAJAY II",
            "KALIBO I",
            "KALIBO II",
            "LEZO",
            "LIBACAO",
            "MADALAG",
            "MAKATO",
            "MALAY",
            "MALINAO",
            "NABAS",
            "NEW WASHINGTON",
            "NUMANCIA",
            "TANGALAN",
        ],
        ANTIQUE: [
            "ANINI-Y",
            "BARBAZA",
            "BELISON",
            "BUGASONG",
            "CALUYA",
            "CULASI",
            "HAMTIC NORTH",
            "HAMTIC SOUTH",
            "LAUA-AN",
            "LIBERTAD",
            "PANDAN",
            "PATNONGON I",
            "PATNONGON II",
            "SAN JOSE",
            "SAN REMEGIO I",
            "SAN REMEGIO II",
            "SEBASTE",
            "SIBALOM NORTH",
            "SIBALOM SOUTH",
            "TIBIAO",
            "TOBIAS FORNIER",
            "VALDERAMA",
        ],
        CAPIZ: [
            "CUARTERO",
            "DAO",
            "DUMALAG",
            "DUMARAO",
            "IVISAN",
            "JAMINDAN",
            "MAAYON",
            "MAMBUSAO EAST",
            "MAMBUSAO WEST",
            "PANAY",
            "PANIT-AN",
            "PILAR",
            "PONTEVEDRA",
            "PRESIDENT ROXAS",
            "SAPIAN",
            "SIGMA",
            "TAPAZ EAST",
            "TAPAZ WEST",
        ],
        GUIMARAS: [
            "BUENAVISTA I",
            "BUENAVISTA II",
            "JORDAN I",
            "JORDAN II",
            "NUEVA VALENCIA NORTH",
            "NUEVA VALENCIA SOUTH",
            "SAN LORENZO (BUENAVISTA III)",
            "SIBUNAG (JORDAN III)",
        ],
        ILOILO: [
            "AJUY",
            "ALIMODIAN I",
            "ALIMODIAN II",
            "ANILAO",
            "BADIANGAN",
            "BALASAN",
            "BANATE",
            "BAROTAC NUEVO",
            "BAROTAC VIEJO",
            "BATAD",
            "BINGAWAN",
            "CABATUAN I",
            "CABATUAN II",
            "CALINOG I",
            "CALINOG II",
            "CARLES",
            "CONCEPCION",
            "DINGLE",
            "DUE¤AS",
            "DUMANGAS I",
            "DUMANGAS II",
            "ESTANCIA",
            "GUIMBAL",
            "IGBARAS",
            "JANIUAY I",
            "JANIUAY II",
            "LAMBUNAO EAST",
            "LAMBUNAO WEST",
            "LEGANES",
            "LEMERY",
            "LEON I",
            "LEON II",
            "MAASIN",
            "MIAGAO EAST",
            "MIAGAO WEST",
            "MINA",
            "NEW LUCENA",
            "OTON",
            "PAVIA",
            "POTOTAN I",
            "POTOTAN II",
            "SAN DIONISIO",
            "SAN ENRIQUE",
            "SAN JOAQUIN NORTH",
            "SAN JOAQUIN SOUTH",
            "SAN MIGUEL",
            "SAN RAFAEL",
            "SARA",
            "STA. BARBARA",
            "TIGBAUAN",
            "TUBUNGAN",
            "ZARRAGA",
        ],
        "ILOILO CITY": [
            "AREVALO",
            "CITY PROPER",
            "JARO",
            "LAPAZ",
            "MANDURRIAO",
            "MOLO",
            "MONTES-LAPUZ",
        ],
        "PASSI CITY": [
            "PASSI CITY DISTRICT I (WEST)",
            "PASSI CITY DISTRICT II (EAST)",
        ],
        "ROXAS CITY": [
            "ROXAS CITY DISTRICT I",
            "ROXAS CITY DISTRICT II",
            "ROXAS CITY DISTRICT III",
        ],
    },
    "07": {
        "BOGO CITY": ["BOGO I", "BOGO II", "BOGO III"],
        BOHOL: [
            "ALBURQUERQUE",
            "ALICIA",
            "ANDA",
            "ANTEQUERA",
            "BACLAYON",
            "BALILIHAN",
            "BATUAN",
            "BIEN UNIDO",
            "BILAR",
            "BUENAVISTA",
            "CALAPE",
            "CANDIJAY",
            "CARMEN",
            "CATIGBIAN",
            "CLARIN",
            "CORELLA",
            "CORTES",
            "DAGOHOY",
            "DANAO",
            "DAUIS",
            "DIMIAO",
            "DUERO",
            "GARCIA-HERNANDEZ",
            "GETAFE",
            "GUINDULMAN",
            "INABANGA NORTH",
            "INABANGA SOUTH",
            "JAGNA",
            "LILA",
            "LOAY",
            "LOBOC",
            "LOON NORTH",
            "LOON SOUTH",
            "MABINI",
            "MARIBOJOC",
            "PANGLAO",
            "PILAR",
            "PRES. C. P. GARCIA",
            "SAGBAYAN",
            "SAN ISIDRO",
            "SAN MIGUEL",
            "SEVILLA",
            "SIERRA BULLONES",
            "SIKATUNA",
            "TALIBON I",
            "TALIBON II",
            "TRINIDAD",
            "TUBIGON",
            "UBAY I (NORTHEAST)",
            "UBAY II (EAST)",
            "UBAY III (SOUTHWEST)",
            "VALENCIA",
        ],
        "CARCAR CITY": ["CARCAR I", "CARCAR II"],
        CEBU: [
            "ALCANTARA",
            "ALCOY",
            "ALEGRIA",
            "ALOGUINSAN",
            "ARGAO I",
            "ARGAO II",
            "ASTURIAS",
            "BADIAN",
            "BALAMBAN I",
            "BALAMBAN II",
            "BANTAYAN I",
            "BANTAYAN II",
            "BARILI I",
            "BARILI II",
            "BOLJOON",
            "BORBON",
            "CARMEN",
            "CATMON",
            "COMPOSTELA",
            "CONSOLACION",
            "CORDOVA",
            "DAANBANTAYAN I",
            "DAANBANTAYAN II",
            "DALAGUETE I",
            "DALAGUETE II",
            "DUMANJUG I",
            "DUMANJUG II",
            "GINATILAN",
            "LILOAN",
            "MADRIDEJOS",
            "MALABUYOC",
            "MEDELLIN",
            "MINGLANILLA I",
            "MINGLANILLA II",
            "MOALBOAL",
            "OSLOB",
            "PILAR",
            "PINAMUNGAJAN 1",
            "PINAMUNGAJAN 2",
            "PORO",
            "RONDA",
            "SAMBOAN",
            "SAN FERNANDO",
            "SAN FRANCISCO",
            "SAN REMEGIO I",
            "SAN REMEGIO II",
            "SANTA FE",
            "SANTANDER",
            "SIBONGA",
            "SOGOD",
            "TABOGON",
            "TABUELAN",
            "TUBURAN I",
            "TUBURAN II",
            "TUDELA",
        ],
        "CEBU CITY": [
            "NORTH DISTRICT 1",
            "NORTH DISTRICT 2",
            "NORTH DISTRICT 3",
            "NORTH DISTRICT 4",
            "NORTH DISTRICT 5",
            "NORTH DISTRICT 6",
            "NORTH DISTRICT 7",
            "NORTH DISTRICT 8",
            "SOUTH DISTRICT 1",
            "SOUTH DISTRICT 2",
            "SOUTH DISTRICT 3",
            "SOUTH DISTRICT 4",
            "SOUTH DISTRICT 5",
            "SOUTH DISTRICT 6",
            "SOUTH DISTRICT 7",
            "SOUTH DISTRICT 8",
        ],
        "CEBU PROVINCE": ["LILOAN"],
        "CITY OF NAGA, CEBU": ["NAGA I", "NAGA II", "NAGA III"],
        "DANAO CITY": [
            "DANAO CITY EAST",
            "DANAO CITY NORTH",
            "DANAO CITY SOUTH",
            "DANAO CITY WEST",
        ],
        "LAPU-LAPU CITY": [
            "LAPU-LAPU CITY EAST DISTRICT",
            "LAPU-LAPU CITY NORTH DISTRICT",
            "LAPU-LAPU CITY SOUTH DISTRICT",
            "LAPU-LAPU CITY WEST DISTRICT",
        ],
        "MANDAUE CITY": [
            "MANDAUE CITY CENTRAL DISTRICT",
            "MANDAUE CITY NORTH DISTRICT",
            "MANDAUE CITY SOUTH DISTRICT",
            "MANDAUE CITY WEST DISTRICT",
        ],
        "TAGBILARAN CITY": ["TAGBILARAN CITY"],
        "TALISAY CITY": [
            "TALISAY CITY I",
            "TALISAY CITY II",
            "TALISAY CITY III",
        ],
        "TOLEDO CITY": [
            "TOLEDO CITY EAST DISTRICT",
            "TOLEDO CITY NORTH DISTRICT",
            "TOLEDO CITY SOUTH DISTRICT",
            "TOLEDO CITY WEST DISTRICT",
        ],
    },
    "08": {
        "BAYBAY CITY": ["BAYBAY I", "BAYBAY II", "BAYBAY III", "BAYBAY IV"],
        BILIRAN: [
            "ALMERIA",
            "BILIRAN",
            "CABUCGAYAN",
            "CAIBIRAN",
            "CULABA",
            "KAWAYAN",
            "MARIPIPI",
            "NAVAL NORTH",
            "NAVAL SOUTH",
        ],
        "BORONGAN CITY": ["BORONGAN EAST", "BORONGAN NORTH", "BORONGAN SOUTH"],
        "CALBAYOG CITY": [
            "CALBAYOG DISTRICT I",
            "CALBAYOG DISTRICT II",
            "CALBAYOG DISTRICT III",
            "CALBAYOG DISTRICT IV",
            "CALBAYOG DISTRICT V",
            "OQUENDO DISTRICT I",
            "OQUENDO DISTRICT II",
            "TINAMBACAN DISTRICT I",
            "TINAMBACAN DISTRICT II",
            "TINAMBACAN DISTRICT III",
        ],
        "CATBALOGAN CITY": [
            "CATBALOGAN I",
            "CATBALOGAN II",
            "CATBALOGAN III",
            "CATBALOGAN IV",
            "CATBALOGAN V",
        ],
        "EASTERN SAMAR": [
            "ARTECHE",
            "BALANGIGA-LAWAAN",
            "BALANGKAYAN",
            "CAN-AVID",
            "DOLORES I",
            "DOLORES II",
            "GENERAL MACARTHUR-HERNANI",
            "GIPORLOS",
            "GUIUAN EAST",
            "GUIUAN NORTH",
            "GUIUAN SOUTH",
            "HERNANI",
            "JIPAPAD",
            "LAWAAN",
            "LLORENTE",
            "MASLOG",
            "MAYDOLONG",
            "MERCEDES",
            "ORAS EAST",
            "ORAS WEST",
            "QUINAPUNDAN",
            "SALCEDO I",
            "SALCEDO II",
            "SAN JULIAN",
            "SAN POLICARPO",
            "SULAT",
            "TAFT",
        ],
        LEYTE: [
            "ABUYOG EAST",
            "ABUYOG NORTH",
            "ABUYOG SOUTH",
            "ALANGALANG I",
            "ALANGALANG II",
            "ALBUERA NORTH",
            "ALBUERA SOUTH",
            "BABATNGON",
            "BARUGO I",
            "BARUGO II",
            "BATO",
            "BURAUEN NORTH",
            "BURAUEN SOUTH",
            "CALUBIAN NORTH",
            "CALUBIAN SOUTH",
            "CAPOOCAN",
            "CARIGARA I",
            "CARIGARA II",
            "DAGAMI NORTH",
            "DAGAMI SOUTH",
            "DULAG NORTH",
            "DULAG SOUTH",
            "HILONGOS NORTH",
            "HILONGOS SOUTH",
            "HINDANG",
            "INOPACAN",
            "ISABEL",
            "JARO I",
            "JARO II",
            "JAVIER",
            "JULITA",
            "KANANGA I",
            "KANANGA II",
            "LA PAZ",
            "LEYTE I",
            "LEYTE II",
            "MACARTHUR",
            "MAHAPLAG",
            "MATAG-OB",
            "MATALOM NORTH",
            "MATALOM SOUTH",
            "MAYORGA",
            "MERIDA",
            "PALO I",
            "PALO II",
            "PALOMPON NORTH",
            "PALOMPON SOUTH",
            "PASTRANA",
            "SAN ISIDRO",
            "SAN MIGUEL",
            "STA. FE",
            "TABANGO NORTH",
            "TABANGO SOUTH",
            "TABONTABON",
            "TANAUAN I",
            "TANAUAN II",
            "TOLOSA",
            "TUNGA",
            "VILLABA NORTH",
            "VILLABA SOUTH",
        ],
        "MAASIN CITY": [
            "MAASIN CITY DISTRICT IV",
            "MAASIN CITY I",
            "MAASIN CITY II",
            "MAASIN CITY III",
            "MAASIN CITY IV",
        ],
        "NORTHERN SAMAR": [
            "ALLEN",
            "BIRI",
            "BOBON",
            "CAPUL",
            "CATARMAN I",
            "CATARMAN II",
            "CATARMAN III",
            "CATARMAN IV",
            "CATUBIG I",
            "CATUBIG II",
            "GAMAY I",
            "GAMAY II",
            "LAOANG I",
            "LAOANG II",
            "LAOANG III",
            "LAPINIG",
            "LAS NAVAS I",
            "LAS NAVAS II",
            "LAVEZARES I",
            "LAVEZARES II",
            "LOPE DE VEGA",
            "MAPANAS",
            "MONDRAGON I",
            "MONDRAGON II",
            "PALAPAG I",
            "PALAPAG II",
            "PAMBUJAN I",
            "PAMBUJAN II",
            "ROSARIO",
            "SAN ANTONIO",
            "SAN ISIDRO",
            "SAN JOSE",
            "SAN ROQUE",
            "SAN VICENTE",
            "SILVINO LUBOS",
            "VICTORIA",
        ],
        "ORMOC CITY": [
            "ORMOC I",
            "ORMOC II",
            "ORMOC III",
            "ORMOC IV",
            "ORMOC V",
            "ORMOC VI",
        ],
        "SAMAR (WESTERN SAMAR)": [
            "ALMAGRO",
            "BASEY I",
            "BASEY II",
            "CALBIGA",
            "DARAM I",
            "DARAM II",
            "GANDARA I",
            "GANDARA II - MATUGUINAO",
            "HINABANGAN",
            "JIABONG",
            "MARABUT",
            "MOTIONG",
            "PAGSANGHAN",
            "PINABACDAO",
            "SAN JORGE",
            "SAN SEBASTIAN",
            "STA. MARGARITA I",
            "STA. MARGARITA II",
            "STA. RITA I",
            "STA. RITA II",
            "STO. NINO",
            "TAGAPUL-AN",
            "TALALORA",
            "TARANGNAN",
            "VILLAREAL I",
            "VILLAREAL II",
            "WRIGHT I",
            "WRIGHT II -SAN JOSE DE BUAN",
            "ZUMARRAGA",
        ],
        "SOUTHERN LEYTE": [
            "ANAHAWAN",
            "BONTOC I",
            "BONTOC II",
            "HINUNANGAN",
            "HINUNDAYAN",
            "LIBAGON",
            "LILOAN",
            "LIMASAWA",
            "MACROHON",
            "MALITBOG",
            "PADRE BURGOS",
            "PINTUYAN",
            "SAN FRANCISCO",
            "SAN JUAN (CABALIAN)",
            "SAN RICARDO",
            "SILAGO",
            "SOGOD I",
            "SOGOD II",
            "ST. BERNARD",
            "TOMAS OPPUS",
        ],
        "TACLOBAN CITY": [
            "DISTRICT LEARNING CENTER I",
            "DISTRICT LEARNING CENTER II",
            "DISTRICT LEARNING CENTER III",
            "DISTRICT LEARNING CENTER IV",
            "DISTRICT LEARNING CENTER V",
            "DISTRICT LEARNING CENTER VI",
        ],
    },
    "09": {
        "DAPITAN CITY": [
            "BARCELONA",
            "BAYLIMANGO",
            "DAPITAN CENTRAL",
            "POTUNGAN",
            "SULANGON",
        ],
        "DIPOLOG CITY": [
            "DIPOLOG CITY EAST",
            "DIPOLOG CITY NORTH",
            "DIPOLOG CITY SOUTH",
            "DIPOLOG CITY WEST",
        ],
        "ISABELA CITY": [
            "ISABELA CITY EAST DISTRICT",
            "ISABELA CITY ISLAND DISTRICT",
            "ISABELA CITY NORTH DISTRICT",
            "ISABELA CITY WEST DISTRICT",
        ],
        "PAGADIAN CITY": [
            "PAGADIAN CITY CENTRAL DISTRICT",
            "PAGADIAN CITY EAST DISTRICT",
            "PAGADIAN CITY NORTH DISTRICT",
            "PAGADIAN CITY SOUTH DISTRICT",
            "PAGADIAN CITY WEST DISTRICT",
        ],
        "ZAMBOANGA CITY": [
            "AYALA",
            "BALIWASAN",
            "CURUAN",
            "LABUAN",
            "MANICAHAN",
            "MERCEDES",
            "PUTIK",
            "STA. MARIA",
            "TALON-TALON",
            "TETUAN",
            "VITALI",
            "ZAMBOANGA CENTRAL DISTRICT",
        ],
        "ZAMBOANGA DEL NORTE": [
            "BACUNGAN (LEON POSTIGO)",
            "BALIGUIAN",
            "GODOD",
            "GUTALAC I",
            "GUTALAC II",
            "KALAWIT",
            "KATIPUNAN I",
            "KATIPUNAN II",
            "LA LIBERTAD",
            "LABASON",
            "LILOY I",
            "LILOY II",
            "MANUKAN I",
            "MANUKAN II",
            "MUTIA",
            "PIÑAN",
            "POLANCO I",
            "POLANCO II",
            "PONOT (JOSE DALMAN)",
            "RIZAL",
            "ROXAS I (MANUEL A. ROXAS)",
            "ROXAS II (MANUEL A. ROXAS)",
            "SALUG I",
            "SALUG II",
            "SERGIO OSMEÑA I",
            "SERGIO OSMEÑA II",
            "SIAYAN",
            "SIBUCO",
            "SIBUTAD",
            "SINDANGAN CENTRAL",
            "SINDANGAN NORTH",
            "SINDANGAN SOUTH",
            "SIOCON",
            "SIRAWAI",
            "TAMPILISAN",
        ],
        "ZAMBOANGA DEL SUR": [
            "AURORA EAST",
            "AURORA WEST",
            "BAYOG",
            "DIMATALING",
            "DINAS",
            "DUMALINAO",
            "DUMINGAG I",
            "DUMINGAG II",
            "GUIPOS",
            "JOSEFINA",
            "KUMALARANG",
            "LABANGAN I",
            "LABANGAN II",
            "LAKEWOOD",
            "LAPUYAN",
            "MAHAYAG NORTH",
            "MAHAYAG SOUTH",
            "MARGOSATUBIG",
            "MIDSALIP",
            "MOLAVE EAST",
            "MOLAVE WEST",
            "PITOGO",
            "RAMON MAGSAYSAY",
            "SAN MIGUEL",
            "SAN PABLO",
            "SOMINOT",
            "TABINA",
            "TAMBULIG",
            "TIGBAO",
            "TUKURAN EAST",
            "TUKURAN WEST",
            "VINCENZO SAGUN",
        ],
        "ZAMBOANGA SIBUGAY": [
            "ALICIA",
            "BUUG",
            "DIPLAHAN",
            "IMELDA",
            "IPIL",
            "KABASALAN",
            "MABUHAY",
            "MALANGAS",
            "NAGA",
            "OLUTANGA",
            "PAYAO",
            "R.T. LIM",
            "SIAY",
            "TALUSAN",
            "TITAY",
            "TUNGAWAN",
        ],
    },
    "10": {
        BUKIDNON: [
            "BAUNGON",
            "CABANGLASAN",
            "DAMULOG",
            "DANGCAGAN",
            "DON CARLOS I",
            "DON CARLOS II",
            "IMPASUG-ONG I",
            "IMPASUG-ONG II",
            "KADINGILAN",
            "KALILANGAN",
            "KIBAWE",
            "KITAOTAO I",
            "KITAOTAO II",
            "LANTAPAN",
            "LIBONA",
            "MALITBOG",
            "MANOLO FORTICH I",
            "MANOLO FORTICH II",
            "MARAMAG I",
            "MARAMAG II",
            "MARAMAG III",
            "PANGANTUCAN",
            "PANGANTUCAN SOUTH DISTRICT",
            "QUEZON I",
            "QUEZON II",
            "SAN FERNANDO I",
            "SAN FERNANDO II",
            "SUMILAO",
            "TALAKAG I",
            "TALAKAG II",
        ],
        "CAGAYAN DE ORO CITY": [
            "CAGAYAN DE ORO CITY CENTRAL I DISTRICT",
            "CAGAYAN DE ORO CITY EAST I DISTRICT",
            "CAGAYAN DE ORO CITY EAST II DISTRICT",
            "CAGAYAN DE ORO CITY NORTH I DISTRICT",
            "CAGAYAN DE ORO CITY NORTH II DISTRICT",
            "CAGAYAN DE ORO CITY SOUTH DISTRICT",
            "CAGAYAN DE ORO CITY SOUTHWEST DISTRICT I",
            "CAGAYAN DE ORO CITY SOUTHWEST DISTRICT II",
            "CAGAYAN DE ORO CITY WEST I DISTRICT",
            "CAGAYAN DE ORO CITY WEST II DISTRICT",
        ],
        CAMIGUIN: ["CATARMAN", "MAHINOG", "MAMBAJAO", "SAGAY-GUINSILIBAN"],
        "EL SALVADOR": ["DISTRICT I", "DISTRICT II"],
        "GINGOOG CITY": [
            "GINGOOG CITY EAST-1 DISTRICT",
            "GINGOOG CITY EAST-2 DISTRICT",
            "GINGOOG CITY NORTH-1 DISTRICT",
            "GINGOOG CITY NORTH-2 DISTRICT",
            "GINGOOG CITY NORTH-3 DISTRICT",
            "GINGOOG CITY SOUTH-1 DISTRICT",
            "GINGOOG CITY SOUTH-2 DISTRICT",
            "GINGOOG CITY WEST-1 DISTRICT",
            "GINGOOG CITY WEST-2 DISTRICT",
            "GINGOOG CITY WEST-3 DISTRICT",
        ],
        "ILIGAN CITY": [
            "ILIGAN CITY CENTRAL DISTRICT",
            "ILIGAN CITY EAST I DISTRICT",
            "ILIGAN CITY EAST II DISTRICT",
            "ILIGAN CITY NORTH I DISTRICT",
            "ILIGAN CITY NORTH II DISTRICT",
            "ILIGAN CITY NORTHEAST I - A DISTRICT",
            "ILIGAN CITY NORTHEAST I - B DISTRICT",
            "ILIGAN CITY NORTHEAST II - A DISTRICT",
            "ILIGAN CITY NORTHEAST II - B DISTRICT",
            "ILIGAN CITY SOUTH I - A DISTRICT",
            "ILIGAN CITY SOUTH I - B DISTRICT",
            "ILIGAN CITY SOUTH II DISTRICT",
            "ILIGAN CITY WEST DISTRICT",
        ],
        "LANAO DEL NORTE": [
            "BACOLOD",
            "BALOI EAST",
            "BALOI WEST",
            "BAROY",
            "KAPATAGAN EAST",
            "KAPATAGAN WEST",
            "KAUSWAGAN",
            "KOLAMBUGAN",
            "LALA NORTH",
            "LALA SOUTH",
            "LINAMON",
            "MAGSAYSAY",
            "MAIGO",
            "MATUNGAO",
            "MUNAI",
            "PANTAO-RAGAT",
            "PANTAR",
            "POONAPIAGAPO",
            "SALVADOR",
            "SAPAD - NUNUNGAN",
            "SULTAN NAGA DIMAPORO",
            "TAGOLOAN",
            "TANGKAL",
            "TUBOD EAST",
            "TUBOD WEST",
        ],
        "MALAYBALAY CITY": [
            "MALAYBALAY CITY DISTRICT I",
            "MALAYBALAY CITY DISTRICT II",
            "MALAYBALAY CITY DISTRICT III",
            "MALAYBALAY CITY DISTRICT IV",
            "MALAYBALAY CITY DISTRICT IX",
            "MALAYBALAY CITY DISTRICT V",
            "MALAYBALAY CITY DISTRICT VI",
            "MALAYBALAY CITY DISTRICT VII",
            "MALAYBALAY CITY DISTRICT VIII",
            "MALAYBALAY CITY DISTRICT X",
        ],
        "MISAMIS OCCIDENTAL": [
            "ALORAN",
            "BALIANGAO",
            "BONIFACIO EAST",
            "BONIFACIO WEST",
            "CALAMBA",
            "CLARIN NORTH",
            "CLARIN SOUTH",
            "CONCEPCION",
            "DON VICTORIANO",
            "JIMENEZ",
            "LOPEZ JAENA",
            "PANAON",
            "PLARIDEL NORTH",
            "PLARIDEL SOUTH",
            "SAPANG DALAGA",
            "SINACABAN",
            "TUDELA",
        ],
        "MISAMIS ORIENTAL": [
            "ALUBIJID",
            "BALINGASAG NORTH (BALINGASAG DISTRICT)",
            "BALINGASAG SOUTH (BALINGASAG DISTRICT)",
            "CLAVERIA I (CLAVERIA DISTRICT)",
            "CLAVERIA II (CLAVERIA DISTRICT)",
            "INITAO",
            "JASAAN",
            "KINOGUITAN",
            "LAGONGLONG",
            "LAGUINDINGAN",
            "LIBERTAD",
            "LUGAIT",
            "MAGSAYSAY I (MAGSAYSAY DISTRICT)",
            "MAGSAYSAY II (MAGSAYSAY DISTRICT)",
            "MANTICAO",
            "MEDINA",
            "NAAWAN",
            "OPOL",
            "SALAY",
            "SUGBONGCOGON",
            "TAGOLOAN",
            "TALISAYAN",
            "VILLANUEVA",
        ],
        "OROQUIETA CITY": [
            "CENTRAL DISTRICT I",
            "CENTRAL DISTRICT II",
            "NORTHWEST DISTRICT",
            "SOUTHEAST DISTRICT I",
            "SOUTHEAST DISTRICT II",
            "SOUTHWEST DISTRICT",
        ],
        "OZAMIS CITY": [
            "OZAMIS CITY CENTRAL DISTRICT",
            "OZAMIS CITY DISTRICT I",
            "OZAMIS CITY DISTRICT II",
            "OZAMIS CITY DISTRICT III",
            "OZAMIS CITY DISTRICT IV",
        ],
        "TANGUB CITY": [
            "TANGUB CENTRAL DISTRICT",
            "TANGUB NORTH DISTRICT",
            "TANGUB SOUTH DISTRICT",
            "TANGUB SOUTHWEST DISTRICT",
        ],
        "VALENCIA CITY": [
            "DISTRICT I",
            "DISTRICT II",
            "DISTRICT III",
            "DISTRICT IV",
            "DISTRICT V",
            "DISTRICT VI",
            "DISTRICT VII",
        ],
    },
    "11": {
        "DAVAO CITY": [
            "BAGUIO",
            "BANGOY",
            "BINUGAO",
            "BUHANGIN",
            "BUNAWAN",
            "CALINAN",
            "DALIAON",
            "DAVAO CENTRAL",
            "GENERAL ROXAS",
            "MAA",
            "MALABOG",
            "MARILOG",
            "MATINA",
            "PAQUIBATO",
            "PIEDAD",
            "SAN ROQUE",
            "STA. ANA",
            "TALOMO",
            "TIBUNGCO",
            "TUGBOK",
        ],
        "DAVAO DE ORO": [
            "COMPOSTELA",
            "LAAK",
            "MABINI",
            "MACO NORTH",
            "MACO SOUTH",
            "MARAGUSAN",
            "MAWAB",
            "MONCAYO",
            "MONTEVISTA",
            "NABUNTURAN EAST",
            "NABUNTURAN WEST",
            "NEW BATAAN",
            "PANTUKAN",
        ],
        "DAVAO DEL NORTE": [
            "ASUNCION",
            "BRAULIO DUJALI",
            "CARMEN",
            "KAPALONG EAST",
            "KAPALONG WEST",
            "NEW CORELLA",
            "SAN ISIDRO",
            "STO. TOMAS EAST",
            "STO. TOMAS WEST",
            "TALAINGOD",
        ],
        "DAVAO DEL SUR": [
            "BANSALAN EAST",
            "BANSALAN WEST",
            "HAGONOY I",
            "HAGONOY II",
            "KIBLAWAN",
            "MAGSAYSAY NORTH",
            "MAGSAYSAY SOUTH",
            "MALALAG",
            "MATANAO I",
            "MATANAO II",
            "PADADA",
            "STA. CRUZ NORTH",
            "STA. CRUZ SOUTH",
            "SULOP",
        ],
        "DAVAO OCCIDENTAL": [
            "DON MARCELINO",
            "JOSE ABAD SANTOS",
            "JOSE ABAD SANTOS I",
            "JOSE ABAD SANTOS II",
            "MALITA",
            "MALITA EAST",
            "MALITA NORTH",
            "MALITA SOUTH",
            "MALITA WEST",
            "SARANGANI",
            "STA. MARIA",
            "STA. MARIA EAST",
            "STA. MARIA WEST",
        ],
        "DAVAO ORIENTAL": [
            "BAGANGA NORTH",
            "BAGANGA SOUTH",
            "BANAYBANAY",
            "BOSTON",
            "CARAGA NORTH",
            "CARAGA SOUTH",
            "CATEEL I",
            "CATEEL II",
            "GOV. GENEROSO NORTH",
            "GOV. GENEROSO SOUTH",
            "LUPON EAST",
            "LUPON WEST",
            "MANAY",
            "SAN ISIDRO NORTH",
            "SAN ISIDRO SOUTH",
            "TARRAGONA",
        ],
        "DIGOS CITY": ["DIGOS OCCIDENTAL", "DIGOS ORIENTAL", "MT. APO"],
        "ISLAND GARDEN CITY OF SAMAL": ["BABAK", "KAPUTIAN", "SAMAL"],
        "MATI CITY": ["MATI CENTRAL", "MATI NORTH", "MATI SOUTH"],
        "PANABO CITY": ["PANABO CENTRAL", "PANABO NORTH", "PANABO SOUTH"],
        "TAGUM CITY": [
            "TAGUM CITY CENTRAL",
            "TAGUM CITY NORTH",
            "TAGUM CITY SOUTH",
        ],
    },
    "12": {
        "GENERAL SANTOS CITY": [
            "ACHARON",
            "APOPONG",
            "BUAYAN",
            "BULA",
            "CAHILSOT",
            "CONEL",
            "GENERAL SANTOS CITY NORTH DISTRICT",
            "GENERAL SANTOS CITY SOUTH DISTRICT",
            "GENERAL SANTOS CITY WEST DISTRICT",
            "KATANGAWAN",
            "LABANGAL",
            "NORTH FATIMA",
            "PEDRO ACHARON",
            "SOUTH FATIMA",
            "TAMBLER",
        ],
        "KIDAPAWAN CITY": [
            "KIDAPAWAN CITY DISTRICT I",
            "KIDAPAWAN CITY DISTRICT II",
            "KIDAPAWAN CITY DISTRICT III",
            "KIDAPAWAN CITY DISTRICT IV",
            "KIDAPAWAN CITY DISTRICT V",
        ],
        "KORONADAL CITY": [
            "KORONADAL EAST DISTRICT I",
            "KORONADAL EAST DISTRICT II",
            "KORONADAL SOUTH DISTRICT I",
            "KORONADAL SOUTH DISTRICT II",
            "KORONADAL WEST DISTRICT I",
            "KORONADAL WEST DISTRICT II",
        ],
        "NORTH COTABATO": [
            "ALAMADA EAST",
            "ALAMADA NORTH",
            "ALAMADA WEST",
            "ALEOSAN EAST",
            "ALEOSAN WEST",
            "ANTIPAS",
            "ARAKAN EAST",
            "ARAKAN NORTH",
            "ARAKAN WEST",
            "BANISILAN NORTH",
            "BANISILAN SOUTH",
            "BANISILAN WEST",
            "CARMEN NORTH",
            "CARMEN SOUTH",
            "KABACAN NORTH",
            "KABACAN SOUTH",
            "KABACAN WEST",
            "LIBUNGAN EAST",
            "LIBUNGAN WEST",
            "M'LANG  EAST",
            "M'LANG CENTRAL",
            "M'LANG NORTH",
            "M'LANG SOUTH",
            "MAGPET  EAST",
            "MAGPET WEST",
            "MAKILALA CENTRAL",
            "MAKILALA EAST",
            "MAKILALA NORTH",
            "MAKILALA WEST",
            "MATALAM CENTRAL",
            "MATALAM NORTH",
            "MATALAM SOUTH",
            "MATALAM WEST",
            "MIDSAYAP CENTRAL",
            "MIDSAYAP NORTH",
            "MIDSAYAP SOUTH",
            "MIDSAYAP SOUTH-WEST",
            "MIDSAYAP WEST",
            "PIGCAWAYAN NORTH",
            "PIGCAWAYAN SOUTH",
            "PIGCAWAYAN WEST",
            "PIKIT EAST",
            "PIKIT NORTH",
            "PIKIT SOUTH",
            "PIKIT WEST",
            "PRESIDENT ROXAS CENTRAL",
            "PRESIDENT ROXAS NORTH",
            "PRESIDENT ROXAS SOUTH",
            "TULUNAN EAST",
            "TULUNAN NORTH",
            "TULUNAN SOUTH",
        ],
        SARANGANI: [
            "CENTRAL GLAN",
            "EAST ALABEL",
            "EAST KIAMBA",
            "EAST MAASIM",
            "EAST MAITUM",
            "EAST MALUNGON",
            "MALAPATAN I",
            "MALAPATAN II",
            "MALAPATAN III",
            "NORTH GLAN",
            "NORTH GLAN - CLUSTER A",
            "NORTH GLAN - CLUSTER B",
            "NORTH MALUNGON",
            "SOUTH GLAN",
            "SOUTH GLAN - CLUSTER A",
            "SOUTH MALUNGON",
            "SOUTHWEST ALABEL",
            "WEST ALABEL",
            "WEST KIAMBA",
            "WEST MAASIM",
            "WEST MAITUM",
            "WEST MALUNGON",
        ],
        "SOUTH COTABATO": [
            "BANGA EAST",
            "BANGA NORTH",
            "BANGA SOUTH",
            "LAKE SEBU EAST",
            "LAKE SEBU WEST",
            "NORALA",
            "POLOMOLOK EAST",
            "POLOMOLOK WEST",
            "STO. NIÑO",
            "SURALLAH CENTRAL",
            "SURALLAH NORTH",
            "SURALLAH SOUTH",
            "T ' BOLI EAST",
            "T ' BOLI WEST",
            "TAMPAKAN",
            "TANTANGAN",
            "TUPI NORTH",
            "TUPI SOUTH",
        ],
        "SULTAN KUDARAT": [
            "BAGUMBAYAN I",
            "BAGUMBAYAN II",
            "BAGUMBAYAN III",
            "COLUMBIO I",
            "COLUMBIO II",
            "ESPERANZA I",
            "ESPERANZA II",
            "ESPERANZA III",
            "ISULAN CENTRAL",
            "ISULAN EAST",
            "ISULAN SOUTH",
            "ISULAN WEST",
            "KALAMANSIG I",
            "KALAMANSIG II",
            "KULAMAN I (SEN. N. AQUINO)",
            "KULAMAN II",
            "LAMBAYONG I",
            "LAMBAYONG II",
            "LAMBAYONG III",
            "LEBAK CENTRAL",
            "LEBAK EAST",
            "LEBAK WEST",
            "LUTAYAN I",
            "LUTAYAN II",
            "PALIMBANG I",
            "PALIMBANG II",
            "PRES. QUIRINO NORTH",
            "PRES. QUIRINO SOUTH",
        ],
        "TACURONG CITY": [
            "TACURONG CENTRAL",
            "TACURONG EAST",
            "TACURONG NORTH",
            "TACURONG SOUTH",
            "TACURONG WEST",
        ],
    },
    "13": {
        "AGUSAN DEL NORTE": [
            "BUENAVISTA I",
            "BUENAVISTA II",
            "BUENAVISTA III",
            "BUENAVISTA IV",
            "CARMEN",
            "CENTRAL BUTUAN DISTRICT I",
            "JABONGA I",
            "JABONGA II",
            "KITCHARAO",
            "LAS NIEVES EAST",
            "LAS NIEVES WEST",
            "MAGALLANES",
            "NASIPIT EAST",
            "NASIPIT WEST",
            "R.T. ROMUALDEZ",
            "SANTIAGO",
            "TUBAY I",
            "TUBAY II",
        ],
        "AGUSAN DEL SUR": [
            "BUNAWAN I",
            "BUNAWAN II",
            "CURRICULUM IMPLEMENTATION DIVISION (AGUSAN DEL SUR DIVISION)",
            "ESPERANZA I",
            "ESPERANZA II",
            "ESPERANZA III",
            "LA PAZ I",
            "LA PAZ II",
            "LORETO NORTH",
            "LORETO SOUTH",
            "PROSPERIDAD I",
            "PROSPERIDAD II",
            "PROSPERIDAD III",
            "PROSPERIDAD IV",
            "ROSARIO I",
            "ROSARIO II",
            "SAN FRANCISCO I",
            "SAN FRANCISCO II",
            "SAN FRANCISCO III",
            "SAN FRANCISCO IV",
            "SAN LUIS I",
            "SAN LUIS II",
            "SIBAGAT I",
            "SIBAGAT II",
            "STA. JOSEFA",
            "TALACOGON EAST",
            "TALACOGON WEST",
            "TRENTO I",
            "TRENTO II",
            "VERUELA I",
            "VERUELA II",
        ],
        "BAYUGAN CITY": [
            "BAYUGAN CENTRAL",
            "BAYUGAN EAST",
            "BAYUGAN NORTH",
            "BAYUGAN SOUTH",
            "BAYUGAN WEST",
        ],
        "BISLIG CITY": [
            "BISLIG CITY I",
            "BISLIG CITY II",
            "MANGAGOY I",
            "MANGAGOY II",
        ],
        "BUTUAN CITY": [
            "CENTRAL BUTUAN DISTRICT I",
            "CENTRAL BUTUAN DISTRICT II",
            "EAST BUTUAN DISTRICT I",
            "EAST BUTUAN DISTRICT II",
            "NORTH BUTUAN DISTRICT",
            "NORTHWEST BUTUAN DISTRICT",
            "SOUTH BUTUAN DISTRICT I",
            "SOUTH BUTUAN DISTRICT II",
            "SOUTHEAST I BUTUAN DISTRICT",
            "SOUTHEAST II BUTUAN DISTRICT",
            "SOUTHWEST BUTUAN DISTRICT",
            "WEST BUTUAN DISTRICT I",
            "WEST BUTUAN DISTRICT II",
        ],
        "CABADBARAN CITY": [
            "NORTH CABADBARAN",
            "NORTHWEST CABADBARAN",
            "SOUTH CABADBARAN",
            "SOUTHEAST CABADBARAN",
        ],
        "DINAGAT ISLAND": [
            "ALBOR",
            "CAGDIANAO",
            "DINAGAT",
            "LORETO",
            "RIZAL",
            "RIZAL II",
            "SAN JOSE",
            "TUBAJON",
        ],
        SIARGAO: [
            "BURGOS",
            "DAPA EAST",
            "DAPA WEST",
            "GENERAL LUNA",
            "NUMANCIA EAST",
            "NUMANCIA WEST",
            "PILAR",
            "SAN BENITO",
            "SAN ISIDRO",
            "SAPAO",
            "SOCORRO EAST DISTRICT",
            "SOCORRO WEST DISTRICT",
        ],
        "SURIGAO CITY": [
            "SURIGAO CITY DISTRICT I",
            "SURIGAO CITY DISTRICT II",
            "SURIGAO CITY DISTRICT III",
            "SURIGAO CITY DISTRICT IV",
            "SURIGAO CITY DISTRICT V",
            "SURIGAO CITY DISTRICT VI",
            "SURIGAO CITY DISTRICT VII",
            "SURIGAO CITY DISTRICT VIII",
        ],
        "SURIGAO DEL NORTE": [
            "ALEGRIA",
            "ANAO-AON",
            "BACUAG",
            "CLAVER",
            "GIGAQUIT",
            "MAINIT I",
            "MAINIT II",
            "MALIMONO",
            "PLACER I",
            "PLACER II",
            "SISON",
            "TAGANA-AN",
            "TUBOD",
        ],
        "SURIGAO DEL SUR": [
            "BAROBO I",
            "BAROBO II",
            "BAYABAS",
            "CAGWAIT",
            "CANTILAN I",
            "CANTILAN II",
            "CARMEN",
            "CARRASCAL",
            "CORTES",
            "HINATUAN NORTH",
            "HINATUAN SOUTH",
            "LANUZA",
            "LIANGA",
            "LINGIG I",
            "LINGIG II",
            "MADRID",
            "MARIHATAG",
            "SAN AGUSTIN",
            "SAN MIGUEL I",
            "SAN MIGUEL II",
            "TAGBINA I",
            "TAGBINA II",
            "TAGO I",
            "TAGO II",
        ],
        "TANDAG CITY": ["TANDAG I", "TANDAG II"],
    },
    "14": {
        BASILAN: [
            "LAMITAN EAST",
            "LANTAWAN",
            "MALUSO EAST",
            "MALUSO WEST",
            "PILAS",
            "SUMISIP EAST",
            "SUMISIP NORTH",
            "SUMISIP SOUTH",
            "TIPO-TIPO EAST",
            "TIPO-TIPO WEST",
            "TUBURAN",
        ],
        "COTABATO CITY": [
            "COTABATO CITY DISTRICT I",
            "COTABATO CITY DISTRICT II",
            "COTABATO CITY DISTRICT III",
            "COTABATO CITY DISTRICT IV",
            "COTABATO CITY DISTRICT V",
            "COTABATO CITY DISTRICT VI",
            "COTABATO CITY DISTRICT VII",
            "COTABATO CITY DISTRICT VIII",
        ],
        "LAMITAN CITY": [
            "LAMITAN CENTRAL",
            "LAMITAN EAST",
            "LAMITAN SOUTH",
            "LAMITAN WEST I",
            "LAMITAN WEST II",
        ],
        "LANAO DEL SUR - I": [
            "BALINDONG I",
            "BALINDONG II",
            "BUADIPUSO-BUNTONG",
            "BUBONG I",
            "BUBONG II",
            "BUMBARAN",
            "DITSAAN RAMAIN I",
            "DITSAAN RAMAIN II",
            "DITSAAN RAMAIN III",
            "KAPAI/TAGOLOAN",
            "LUMBA-BAYABAO I",
            "LUMBA-BAYABAO II",
            "LUMBA-BAYABAO III",
            "MAGUING",
            "MAGUING II",
            "MARANTAO I",
            "MARANTAO II",
            "MASIU A DISTRICT",
            "MASIU B DISTRICT",
            "MASIU I",
            "MASIU II",
            "MULONDO",
            "PIAGAPO EAST",
            "PIAGAPO WEST",
            "POONA-BAYABAO NORTH",
            "POONA-BAYABAO SOUTH",
            "POONA-BAYABAO WEST",
            "SAGUIARAN I",
            "SAGUIARAN II",
            "SAGUIARAN III",
            "SOUTH WAO DISTRICT",
            "TAMPARAN DISTRICT",
            "TAMPARAN I",
            "TARAKA I",
            "TARAKA II",
            "WAO I",
            "WAO II",
        ],
        "LANAO DEL SUR - II": [
            "BACOLOD",
            "BINIDAYAN",
            "BUTIG",
            "CALANOGAS",
            "CENTRAL GANASSI",
            "CENTRAL TUGAYA",
            "DIWAN",
            "EAST GANASSI",
            "EAST TUGAYA",
            "KALAWI",
            "KAPATAGAN",
            "LOWER BAYANG",
            "LOWER MADAMBA",
            "LUMBACA UNAYAN",
            "LUMBATAN I",
            "LUMBATAN II",
            "LUMBAYANAGUE I",
            "LUMBAYANAGUE II",
            "MAROGONG",
            "NORTH BALABAGAN",
            "NORTH MADALUM",
            "NORTH MALABANG",
            "NORTH PUALAS",
            "PAGAYAWAN",
            "SOUTH BALABAGAN",
            "SOUTH MADALUM",
            "SOUTH MALABANG",
            "SOUTH PUALAS",
            "SULTAN DUMALONDONG",
            "SULTAN GUMANDER",
            "TUBARAN",
            "UPPER BAYANG",
            "UPPER MADAMBA",
            "WEST GANASSI",
            "WEST TUGAYA",
        ],
        "MAGUINDANAO I": [
            "AMPATUAN",
            "BULUAN",
            "DATU ABDULLAH SANGKI",
            "DATU ANGGAL",
            "DATU HOFFER AMPATUAN",
            "DATU MONTAWAL(PAGAGAWAN)",
            "DATU PAGLAS EAST",
            "DATU PAGLAS NORTH",
            "DATU PAGLAS SOUTH",
            "DATU PIANG I",
            "DATU PIANG II",
            "DATU SALIBO",
            "DATU SAUDI UY AMPATUAN",
            "DATU UNSAY",
            "GEN. S. K. PENDATUN",
            "GUINDULUNGAN",
            "MAMASAPANO",
            "MAMASAPANO NORTH",
            "MANGUDADATU",
            "PAGALUNGAN",
            "PAGLAT",
            "PANDAG",
            "RAJAH BUAYAN",
            "SHARIFF AGUAK",
            "SHARIFF SAYDONA MUSTAPHA",
            "SOUTH UPI",
            "SULTAN SA BARONGIS",
            "TALAYAN",
        ],
        "MAGUINDANAO II": [
            "BARIRA",
            "BARIRA NORTH",
            "BARIRA SOUTH",
            "BULDON EAST",
            "BULDON WEST",
            "DATU BLAH SINSUAT",
            "DOS NORTH",
            "DOS SOUTH",
            "INTER PARANG",
            "KABUNTALAN NORTH",
            "KABUNTALAN SOUTH",
            "MATANOG",
            "PARANG BONGO",
            "PARANG NORTH",
            "PARANG SOUTH",
            "SULTAN KUDARAT I",
            "SULTAN KUDARAT II",
            "SULTAN MASTURA",
            "TALITAY",
            "UPI NORTH",
            "UPI WEST",
        ],
        "MARAWI CITY": [
            "ANGOYAO DISTRICT",
            "ANGOYAO EAST DISTRICT",
            "CENTRAL DISTRICT",
            "EAST DISTRICT",
            "NORTH DISTRICT",
            "NORTHEAST -II DISTRICT",
            "NORTHEAST-I DISTRICT",
            "NORTHWEST DISTRICT",
            "WEST DISTRICT",
        ],
        "SPECIAL GEOGRAPHIC AREA DIVISION": [
            "(NO DISTRICT) - FOR SGA DIVISION",
            "ALEOSAN WEST",
            "CARMEN NORTH",
            "CARMEN SOUTH",
            "KABACAN NORTH",
            "KABACAN WEST",
            "MIDSAYAP NORTH",
            "MIDSAYAP SOUTH-WEST",
            "MIDSAYAP WEST",
            "PIGCAWAYAN NORTH",
            "PIGCAWAYAN SOUTH",
            "PIGCAWAYAN WEST",
            "PIKIT EAST",
            "PIKIT NORTH",
            "PIKIT SOUTH",
            "PIKIT WEST",
        ],
        SULU: [
            "INDANAN",
            "JOLO I",
            "JOLO II",
            "JOLO III",
            "JOLO IV",
            "LAMINUSA",
            "LUGUS",
            "LUUK (KALINGGALAN CALAUANG)",
            "MAIMBUNG",
            "PANAMAO",
            "PANGUTARAN",
            "PARANG",
            "PATA",
            "PATIKUL",
            "SIASI I",
            "SIASI II",
            "SIBAUD",
            "TALIPAO",
            "TAPUL",
            "TONGKIL",
        ],
        "TAWI-TAWI": [
            "BONGAO CENTRAL",
            "BONGAO I",
            "BONGAO II",
            "BONGAO III",
            "EAST SIBUTU I (TANDO OWAK)",
            "EAST SIBUTU II (TANDUBANAK)",
            "EAST SOUTH UBIAN",
            "LANGUYAN",
            "MANUKMANGKAW",
            "MAPUN",
            "PANGLIMA SUGALA (BALIMBINGAN)",
            "SAPA-SAPA I",
            "SAPA-SAPA II (BANARAN)",
            "TANDUBAS",
            "TUBIG INDANGAN",
            "WEST SIBUTU/SITANGKAI",
            "WEST SIMUNUL",
            "WEST SOUTH UBIAN",
        ],
    },
    "15": {
        ABRA: [
            "BAAY-LICUAN",
            "BANGUED EAST",
            "BANGUED WEST",
            "BOLINEY",
            "BUCAY",
            "BUCLOC",
            "DAGUIOMAN",
            "DANGLAS",
            "DOLORES",
            "LA PAZ",
            "LACUB",
            "LAGANGILANG",
            "LAGAYAN",
            "LANGIDEN",
            "LUBA",
            "MALIBCONG",
            "MANABO",
            "PENNARUBIA",
            "PIDIGAN",
            "PILAR",
            "SALLAPADAN",
            "SAN ISIDRO",
            "SAN JUAN",
            "SAN QUINTIN",
            "TAYUM",
            "TINEG",
            "TUBO",
            "VILLAVICIOSA",
        ],
        APAYAO: [
            "CALANASAN",
            "FLORA",
            "KABUGAO",
            "LUNA",
            "NORTHERN CONNER",
            "PUDTOL",
            "SOUTHERN CONNER",
            "STA. MARCELA",
        ],
        "BAGUIO CITY": ["DISTRICT I", "DISTRICT II", "DISTRICT III"],
        BENGUET: [
            "ATOK",
            "BAKUN",
            "BOKOD",
            "BUGUIAS",
            "ITOGON I",
            "ITOGON II",
            "KABAYAN",
            "KAPANGAN",
            "KIBUNGAN",
            "LA TRINIDAD",
            "MANKAYAN",
            "SABLAN",
            "TUBA",
            "TUBLAY",
        ],
        IFUGAO: [
            "AGUINALDO",
            "ALFONSO LISTA I",
            "ALFONSO LISTA II",
            "ASIPULO",
            "BANAUE",
            "HINGYON",
            "HUNGDUAN",
            "KIANGAN",
            "LAGAWE",
            "LAMUT",
            "MAYOYAO",
            "TINOC",
        ],
        KALINGA: [
            "BALBALAN",
            "LOWER TANUDAN",
            "LUBUAGAN",
            "NORTHERN PINUKPUK",
            "PASIL",
            "RIZAL",
            "SOUTHERN PINUKPUK",
            "TINGLAYAN",
            "UPPER TANUDAN",
        ],
        "MT. PROVINCE": [
            "BARLIG",
            "BAUKO I",
            "BAUKO II",
            "BESAO",
            "BONTOC",
            "NATONIN",
            "PARACELIS",
            "SABANGAN",
            "SADANGA",
            "SAGADA",
            "TADIAN I",
            "TADIAN II",
        ],
        "TABUK CITY": [
            "EASTERN TABUK DISTRICT I",
            "EASTERN TABUK DISTRICT II",
            "EASTERN TABUK DISTRICT III",
            "NOTHERN  TABUK DISTRICT I",
            "NOTHERN  TABUK DISTRICT II",
            "SOUTHERN TABUK DISTRICT I",
            "SOUTHERN TABUK DISTRICT II",
            "SOUTHERN TABUK DISTRICT III",
            "WESTERN TABUK DISTRICT I",
            "WESTERN TABUK DISTRICT II",
        ],
    },
    "18": {
        "BACOLOD CITY": [
            "BACOLOD CITY I DISTRICT",
            "BACOLOD CITY II DISTRICT",
            "BACOLOD CITY III DISTRICT",
            "BACOLOD CITY IV DISTRICT",
            "BACOLOD CITY V DISTRICT",
            "BACOLOD CITY VI DISTRICT",
            "BACOLOD CITY VII DISTRICT",
        ],
        "BAGO CITY": [
            "BAGO CITY I DISTRICT",
            "BAGO CITY II DISTRICT",
            "BAGO CITY III DISTRICT",
            "BAGO CITY IV DISTRICT",
        ],
        "BAIS CITY": ["BAIS CITY NORTH", "BAIS CITY SOUTH"],
        "BAYAWAN CITY": ["BASAY", "BAYAWAN EAST", "BAYAWAN WEST"],
        "CADIZ CITY": [
            "CADIZ CITY I DISTRICT",
            "CADIZ CITY II DISTRICT",
            "CADIZ CITY III DISTRICT",
            "CADIZ CITY IV DISTRICT",
        ],
        "CANLAON CITY": ["CANLAON CITY"],
        "DUMAGUETE CITY": [
            "DUMAGUETE CITY NORTH DISTRICT",
            "DUMAGUETE CITY SOUTH DISTRICT",
            "DUMAGUETE CITY WEST DISTRICT",
        ],
        "ESCALANTE CITY": ["ESCALANTE I", "ESCALANTE II"],
        "GUIHULNGAN CITY": [
            "GUIHULNGAN NORTH",
            "GUIHULNGAN SOUTH",
            "VALLEHERMOSO",
        ],
        "HIMAMAYLAN CITY": ["DISTRICT 1", "DISTRICT 2"],
        "KABANKALAN CITY": [
            "KABANKALAN I",
            "KABANKALAN II",
            "KABANKALAN III",
            "KABANKALAN IV",
            "KABANKALAN V",
        ],
        "LA CARLOTA CITY": [
            "LA CARLOTA CITY DISTRICT   I",
            "LA CARLOTA CITY DISTRICT   II",
            "LA CARLOTA CITY DISTRICT   III",
        ],
        "NEGROS OCCIDENTAL": [
            "BINALBAGAN I",
            "BINALBAGAN II",
            "CALATRAVA I",
            "CALATRAVA II",
            "CANDONI",
            "CAUAYAN I",
            "CAUAYAN II",
            "ENRIQUE B. MAGALONA",
            "HINIGARAN I",
            "HINIGARAN II",
            "HINOBAAN",
            "ILOG I",
            "ILOG II",
            "ISABELA I",
            "ISABELA II",
            "LA CASTELLANA I",
            "LA CASTELLANA II",
            "MANAPLA",
            "MOISES PADILLA",
            "MURCIA I",
            "MURCIA II",
            "PONTEVEDRA I",
            "PONTEVEDRA II",
            "PULUPANDAN",
            "SALVADOR BENEDICTO",
            "SAN ENRIQUE",
            "TALISAY I",
            "TALISAY II",
            "TALISAY III",
            "TOBOSO",
            "VALLADOLID",
        ],
        "NEGROS ORIENTAL": [
            "AMLAN",
            "AYUNGON",
            "BACONG",
            "BINDOY",
            "DAUIN",
            "JIMALALUD",
            "LA LIBERTAD",
            "MABINAY I",
            "MABINAY II",
            "MANJUYOD",
            "SAN JOSE",
            "SIATON EAST",
            "SIATON WEST",
            "SIBULAN",
            "STA. CATALINA NORTH",
            "STA. CATALINA SOUTH",
            "TAYASAN",
            "VALENCIA",
            "ZAMBOANGUITA",
        ],
        "SAGAY CITY": [
            "SAGAY CITY DISTRICT I",
            "SAGAY CITY DISTRICT II",
            "SAGAY CITY DISTRICT III",
        ],
        "SAN CARLOS CITY": [
            "SAN CARLOS CITY DISTRICT I",
            "SAN CARLOS CITY DISTRICT II",
            "SAN CARLOS CITY DISTRICT III",
            "SAN CARLOS CITY DISTRICT IV",
            "SAN CARLOS CITY DISTRICT V",
        ],
        "SILAY CITY": [
            "SILAY CITY DISTRICT I",
            "SILAY CITY DISTRICT II",
            "SILAY CITY DISTRICT III",
            "SILAY CITY DISTRICT IV",
        ],
        "SIPALAY CITY": ["DISTRICT 1", "DISTRICT 2"],
        SIQUIJOR: ["LARENA", "LAZI", "MARIA", "SAN JUAN", "SIQUIJOR"],
        "TANJAY CITY": [
            "PAMPLONA DISTRICT",
            "TANJAY CITY NORTH",
            "TANJAY CITY SOUTH",
            "TANJAY CITY WEST",
        ],
        "VICTORIAS CITY": ["VICTORIAS I", "VICTORIAS II"],
    },
    "40": {
        "ANTIPOLO CITY": [
            "DISTRICT I-A",
            "DISTRICT I-B",
            "DISTRICT I-C",
            "DISTRICT II-A",
            "DISTRICT II-B",
            "DISTRICT II-C",
            "DISTRICT II-D",
        ],
        "BACOOR CITY": ["BACOOR I", "BACOOR II"],
        BATANGAS: [
            "AGONCILLO",
            "ALITAGTAG",
            "BALAYAN EAST",
            "BALAYAN WEST",
            "BALETE",
            "BAUAN",
            "CALACA",
            "CALATAGAN",
            "CUENCA",
            "IBAAN",
            "LAUREL",
            "LEMERY",
            "LIAN",
            "LOBO",
            "MABINI",
            "MALVAR",
            "MATAAS NA KAHOY",
            "NASUGBU EAST",
            "NASUGBU NORTH",
            "NASUGBU WEST",
            "PADRE GARCIA",
            "ROSARIO EAST",
            "ROSARIO WEST",
            "SAN JOSE",
            "SAN JUAN EAST",
            "SAN JUAN WEST",
            "SAN LUIS",
            "SAN NICOLAS",
            "SAN PASCUAL",
            "STA. TERESITA",
            "TAAL",
            "TALISAY",
            "TAYSAN",
            "TINGLOY",
            "TUY",
        ],
        "BATANGAS CITY": [
            "BATANGAS CITY COASTAL DISTRICT",
            "BATANGAS CITY EAST DISTRICT",
            "BATANGAS CITY NEW DISTRICT",
            "BATANGAS CITY NORTH DISTRICT",
            "BATANGAS CITY SOUTH DISTRICT",
            "BATANGAS CITY VERDE ISLAND DISTRICT",
            "BATANGAS CITY WEST DISTRICT",
        ],
        "BINAN CITY": ["BINAN"],
        "CABUYAO CITY": [
            "DISTRICT I",
            "DISTRICT II",
            "DISTRICT III",
            "DISTRICT IV",
            "DISTRICT V",
        ],
        "CALAMBA CITY": [
            "CALAMBA CITY EAST I",
            "CALAMBA CITY EAST II",
            "CALAMBA CITY WEST",
        ],
        CAVITE: [
            "ALFONSO",
            "AMADEO",
            "CARMONA",
            "GENERAL E. AGUINALDO",
            "GENERAL MARIANO ALVAREZ",
            "INDANG I",
            "INDANG II",
            "KAWIT",
            "MAGALLANES",
            "MARAGONDON",
            "MENDEZ",
            "NAIC I",
            "NAIC II",
            "NOVELETA",
            "ROSARIO",
            "SILANG I",
            "SILANG II",
            "TAGAYTAY CITY",
            "TANZA",
            "TERNATE",
            "TRECE MARTIREZ CITY",
        ],
        "CAVITE CITY": [
            "CAVITE CITY I DISTRICT",
            "CAVITE CITY II DISTRICT",
            "CAVITE CITY III DISTRICT",
        ],
        "DASMARINAS CITY": ["DASMARIÑAS I", "DASMARIÑAS II"],
        "GENERAL TRIAS CITY": ["GENERAL TRIAS I", "GENERAL TRIAS II"],
        "IMUS CITY": ["IMUS I", "IMUS II"],
        LAGUNA: [
            "ALAMINOS",
            "BAY",
            "CALAUAN",
            "CAVINTI",
            "FAMY-MABITAC",
            "LILIW",
            "LOS BAÑOS",
            "LUISIANA",
            "LUMBAN-KALAYAAN",
            "MAGDALENA",
            "MAJAYJAY",
            "NAGCARLAN-RIZAL",
            "PAETE",
            "PAGSANJAN",
            "PANGIL-PAKIL",
            "PILA",
            "SANTA CRUZ",
            "SANTA MARIA",
            "SINILOAN",
            "VICTORIA",
        ],
        "LIPA CITY": [
            "LIPA CITY EAST DISTRICT",
            "LIPA CITY NORTH DISRICT",
            "LIPA CITY SOUTH DISTRICT",
            "LIPA CITY WEST DISTRICT",
        ],
        "LUCENA CITY": [
            "LUCENA EAST DISTRICT",
            "LUCENA NORTH DISTRICT",
            "LUCENA SOUTH DISTRICT",
            "LUCENA WEST DISTRICT",
        ],
        QUEZON: [
            "ALABAT",
            "ATIMONAN",
            "BUENAVISTA",
            "BURDEOS",
            "CALAUAG EAST",
            "CALAUAG WEST",
            "CANDELARIA EAST",
            "CANDELARIA WEST",
            "CATANAUAN",
            "DOLORES",
            "GEN. LUNA",
            "GEN. NAKAR",
            "GUINAYANGAN",
            "GUMACA EAST",
            "GUMACA WEST",
            "INFANTA",
            "LOPEZ EAST",
            "LOPEZ WEST",
            "LUCBAN",
            "MACALELON",
            "MAUBAN NORTH",
            "MAUBAN SOUTH",
            "MULANAY",
            "PADRE BURGOS-AGDANGAN",
            "PAGBILAO",
            "PANUKULAN",
            "PATNANUNGAN-JOMALIG",
            "PEREZ",
            "PITOGO",
            "PLARIDEL",
            "POLILLO",
            "QUEZON",
            "REAL",
            "SAMPALOC",
            "SAN ANDRES",
            "SAN ANTONIO",
            "SAN FRANCISCO",
            "SAN NARCISO",
            "SARIAYA EAST",
            "SARIAYA WEST",
            "TAGKAWAYAN",
            "TIAONG",
            "UNISAN",
        ],
        RIZAL: [
            "ANGONO",
            "BARAS",
            "BINANGONAN I",
            "BINANGONAN II",
            "BINANGONAN III",
            "CAINTA I (CAINTA)",
            "CAINTA II",
            "CARDONA",
            "JALAJALA",
            "MORONG",
            "PILILLA",
            "RODRIGUEZ I (RODRIGUEZ)",
            "RODRIGUEZ II",
            "SAN MATEO",
            "TANAY I",
            "TANAY II",
            "TAYTAY I",
            "TAYTAY II",
            "TERESA",
        ],
        "SAN PABLO CITY": [
            "AMBRAY",
            "DAPDAPAN",
            "DEL REMEDIO",
            "FULE ALMEDA",
            "LAKESIDE",
            "SAN FRANCISCO",
            "STO. ANGEL",
        ],
        "SAN PEDRO CITY": ["SAN PEDRO"],
        "STA. ROSA CITY": [
            "CITY OF STA. ROSA DISTRICT I",
            "CITY OF STA. ROSA DISTRICT II",
            "CITY OF STA. ROSA DISTRICT III",
        ],
        "STO. TOMAS CITY": ["STO. TOMAS NORTH", "STO. TOMAS SOUTH"],
        "TANAUAN CITY": [
            "TANAUAN CITY EAST I",
            "TANAUAN CITY EAST II",
            "TANAUAN CITY EAST III",
            "TANAUAN CITY NORTH I",
            "TANAUAN CITY NORTH II",
            "TANAUAN CITY NORTH III",
            "TANAUAN CITY SOUTH I",
            "TANAUAN CITY SOUTH II",
            "TANAUAN CITY WEST I",
            "TANAUAN CITY WEST II",
        ],
        "TAYABAS CITY": ["TAYABAS EAST", "TAYABAS WEST"],
    },
    "41": {
        "CALAPAN CITY": ["CALAPAN EAST", "CALAPAN SOUTH", "CALAPAN WEST"],
        MARINDUQUE: [
            "BOAC NORTH",
            "BOAC SOUTH",
            "BUENAVISTA",
            "GASAN",
            "MOGPOG",
            "SANTA CRUZ EAST",
            "SANTA CRUZ NORTH",
            "SANTA CRUZ SOUTH",
            "TORRIJOS",
        ],
        "OCCIDENTAL MINDORO": [
            "ABRA DE ILOG-PALUAN",
            "CALINTAAN",
            "LOOC",
            "LUBANG",
            "MAGSAYSAY",
            "MAMBURAO",
            "RIZAL",
            "SABLAYAN NORTH",
            "SABLAYAN SOUTH",
            "SAN JOSE EAST",
            "SAN JOSE NORTH",
            "SAN JOSE SOUTH",
            "SAN JOSE WEST",
            "STA. CRUZ",
        ],
        "ORIENTAL MINDORO": [
            "BACO",
            "BANSUD",
            "BONGABONG NORTH",
            "BONGABONG SOUTH",
            "BULALACAO",
            "GLORIA",
            "MANSALAY",
            "NAUJAN EAST",
            "NAUJAN SOUTH",
            "NAUJAN WEST",
            "PINAMALAYAN EAST",
            "PINAMALAYAN WEST",
            "POLA",
            "PUERTO GALERA",
            "ROXAS",
            "SAN TEODORO",
            "SOCORRO",
            "VICTORIA",
        ],
        PALAWAN: [
            "ABORLAN CENTRAL",
            "ABORLAN EAST",
            "ABORLAN WEST",
            "AGUTAYA",
            "ARACELI (ARACELI-DUMARAN)",
            "BALABAC",
            "BATARAZA DISTRICT I",
            "BATARAZA DISTRICT II",
            "BROOKE'S POINT II (S. ESPANOLA)",
            "BUSUANGA",
            "CAGANYANCILLO",
            "CORON COASTAL",
            "CORON INLAND",
            "CULION",
            "CUYO",
            "DUMARAN ISLAND DISTRICT",
            "DUMARAN MAINLAND DISTRICT",
            "EL NIDO DEL NORTE",
            "EL NIDO DEL SUR",
            "LINAPACAN",
            "MAGSAYSAY",
            "NARRA DISTRICT I",
            "NARRA DISTRICT II",
            "NORTH BROOKE'S POINT",
            "QUEZON NORTH",
            "QUEZON SOUTH",
            "RIZAL",
            "ROXAS CENTRAL",
            "ROXAS NORTH",
            "ROXAS SOUTH",
            "SAN VICENTE",
            "SOUTH BROOKE'S POINT",
            "TAYTAY I",
            "TAYTAY II",
            "TAYTAY III",
        ],
        "PUERTO PRINCESA CITY": [
            "PUERTO PRINCESA I DISTRICT",
            "PUERTO PRINCESA II DISTRICT",
            "PUERTO PRINCESA III DISTRICT",
        ],
        ROMBLON: [
            "ALCANTARA",
            "BANTON",
            "CAJIDIOCAN-MAGDIWANG",
            "CONCEPCION",
            "CORCUERA",
            "LOOC",
            "ODIONGAN NORTH",
            "ODIONGAN SOUTH",
            "ROMBLON",
            "SAN AGUSTIN-CALATRAVA",
            "SAN ANDRES",
            "SAN FERNANDO",
            "SAN JOSE-SANTA FE",
        ],
    },
};
